import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

export interface SupervisiAmbulansListFilter {
  tanggal_dari?: string;
  tanggal_sampai?: string;
  ambulans_id?: number;
  signed?: boolean;
  page?: number;
  per_page?: number;
}

async function list(params: SupervisiAmbulansListFilter = {}) {
  const response = await http
    .getDataParam("/supervisi-ambulans", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/supervisi-ambulans/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/supervisi-ambulans", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/supervisi-ambulans/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateItems(
  id: number,
  items: Array<{
    id: number;
    hasil?: "ya" | "tidak" | "na" | null;
    masalah?: string | null;
    rekomendasi?: string | null;
  }>
) {
  const response = await http
    .putData(`/supervisi-ambulans/${id}/items`, { items })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signSupervisor(id: number, data: { password: string }) {
  const response = await http
    .putData(`/supervisi-ambulans/${id}/sign-supervisor`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signKepalaUnit(id: number, data: { password: string }) {
  const response = await http
    .putData(`/supervisi-ambulans/${id}/sign-kepala-unit`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/supervisi-ambulans/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/supervisi-ambulans/${id}/pdf`, "_blank");
}

export default {
  list,
  find,
  create,
  update,
  updateItems,
  signSupervisor,
  signKepalaUnit,
  destroy,
  printPdf,
};
